import ProductIcon from './ProductIcon';
import ProductsList from './ProductList';


export default {
    list: ProductsList,
    icon: ProductIcon,
};
